import { createContext } from 'react';

type ShowAlertConfiguration = (alertIsEnabled: boolean) => void;

const Context = createContext<ShowAlertConfiguration | undefined>(undefined);
Context.displayName = 'LoseInProgressAlert';

export default Context;
